export default "/assets/images/big-sneeze-small.f53a7de8e63376ac.webp";